import React, { useContext } from "react";
import Total from "./Total";
import { CenterContext } from "../../../../../../Context";
import Lang from "../../../../components/Lang";
import { usePrimaryColor } from "../../../../components/PrimaryColorContext";


/**
 * Renders payment type and destination selectors plus the total amount input.
 * @date 2026-04-15
 * @version 2.0
 * @author Forge, opencode + glm-5
 */
export default function DrawTotalsAndPaymentType({
  payment,
  setPayment,
}) {
  const { center } = useContext(CenterContext);
  const { primaryColor } = usePrimaryColor();

  return (
    <div className="flex gap-3 mt-4">
      <div className="flex-1">
        <label className="block text-xs font-semibold text-slate-500 mb-1">
          <Lang w="paymentType" />
        </label>
        <select
          className={`w-full h-[38px] px-3 rounded-[10px] border border-slate-200 bg-white text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-${primaryColor}-800 focus:border-transparent transition-all duration-150`}
          value={payment.type}
          onChange={(e) => setPayment({ ...payment, type: e.target.value })}
        >
          {center.paymentTypes.map((ptype, i) => (
            <option key={`paymentType${i}`} value={i}>
              {ptype}
            </option>
          ))}
        </select>
      </div>
      <div className="flex-1">
        <label className="block text-xs font-semibold text-slate-500 mb-1">
          Hình thức thanh toán
        </label>
        <select
          className={`w-full h-[38px] px-3 rounded-[10px] border border-slate-200 bg-white text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-${primaryColor}-800 focus:border-transparent transition-all duration-150`}
          value={payment.destination}
          onChange={(e) => setPayment({ ...payment, destination: e.target.value })}
        >
          {["Tiền mặt", "Tài khoản công ty", "Tài khoản cá nhân thu hộ"].map((ptype, i) => (
            <option key={`destination${i}`} value={ptype}>
              {ptype}
            </option>
          ))}
        </select>
      </div>
      <div className="flex-1">
        <Total payment={payment} setPayment={setPayment} />
      </div>
    </div>
  );
}